import React, { Component } from 'react';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';
// import shared from '../../../utils/shared.js';
import StorySeattle from './StorySeattle';
import VideoSeattle from './VideoSeattle';
import StoriesSeattle from './StoriesSeattle';
import TimelineSeattle from './TimelineSeattle';
import DonorListSeattle from './DonorListSeattle';
import _ from 'lodash';
import { connect } from 'react-redux';
// import { dp } from '../../../utils/shared.js';
import UserInputSeattle from './UserInputSeattle.jsx';

const STORY = "Story";
const VIDEO = "Video";
const DONOR_LIST = "Donor List";
const TIMELINE = "Timeline";
const USER_INPUT = "User Input";

class ContentSeattle extends Component {
  constructor(props) {
    super(props);
    let radius = this.props.regionWidth
    let top = (this.props.regionHeight - radius) / 2;
    let right = - (this.props.regionWidth / 100 * 36.45);
    this.state = {
      radius: radius,
      top: top,
      right: right,
      content: null
    }
  }

  componentDidMount() {
    this.setupContent();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps !== this.props) {
      this.setupContent();
    }
  }

  setupContent = () => {
    if (this.props.content && this.props.content.children) {
      // Check the length first.
      if (this.props.content.children.length === 1) {
        let type = this.determineContentType(this.props.content.children[0]);
        if (type.name === DONOR_LIST) {
          this.renderDonorList(this.props.content.children, this.props.content);
        } else {
          this.renderContent(this.props.content.children[0], type.name);
        }
      } else if (this.props.content.children.length > 0) {
        let type = this.determineContentType(this.props.content.children[0]);
        switch(type.name) {
          case STORY:
            this.renderStories(this.props.content.children, this.props.content);
          break;
          case TIMELINE:
            this.renderTimeline(this.props.content.children, this.props.content);
          break;
          case DONOR_LIST:
            this.renderDonorList(this.props.content.children, this.props.content);
          break;
          default:
          break;
        }
      }
    }
  }

  determineContentType = (item) => {
    if (item.folder_module.display_module_type === 0) {
      if (item.folder_module.model === "story") {
        let type = _.get(item, 'contents.custom_fields.story_type.val.value', 'single_story')
        switch (type) {
          case 'single_story':
            return { name: "Story" };
          case 'timeline':
            return { name: "Timeline" };
          case "video":
            return { name: "Video" }
          default:
          break;
        }
      } else if (item.folder_module.model === "donor") {
        return { name: DONOR_LIST };
      }
    }

    let categories = this.props.stateContent.display_module_types;
    let itemCategory = _.find(categories, { id: item.folder_module.display_module_type });

    return itemCategory;
  }

  renderContent = (content, type) => {
    let renderedContent = null;
    switch (type) {
      case STORY:
        renderedContent = (<StorySeattle item={content} screen={this.props.screen} regionWidth={this.props.regionWidth} handleSwipeAnimation={this.props.handleSwipeAnimation} cancelSwipeAnimation={this.props.cancelSwipeAnimation}/>);
      break;
      case VIDEO:
        renderedContent = (<VideoSeattle item={content} screen={this.props.screen} regionWidth={this.props.regionWidth} handleSwipeAnimation={this.props.handleSwipeAnimation} cancelSwipeAnimation={this.props.cancelSwipeAnimation}/>);
      break;
      case TIMELINE:
        renderedContent = (<TimelineSeattle items={[content]} screen={this.props.screen} regionWidth={this.props.regionWidth} regionHeight={this.props.regionHeight} handleSwipeAnimation={this.props.handleSwipeAnimation} cancelSwipeAnimation={this.props.cancelSwipeAnimation} />);
      break;
      case USER_INPUT:
        renderedContent = (<UserInputSeattle item={content} regionWidth={this.props.regionWidth} regionHeight={this.props.regionHeight} handleSwipeAnimation={this.props.handleSwipeAnimation} cancelSwipeAnimation={this.props.cancelSwipeAnimation} />);
      break;
      default:
        renderedContent = null;
      break;
    }

    this.setState({
      renderedContent: renderedContent
    });
  }

  renderStories = (content, contentParent) => {
    let renderedContent = (<StoriesSeattle items={content} screen={this.props.screen} parent={contentParent} rows={3} columns={3} regionWidth={this.props.regionWidth} handleSwipeAnimation={this.props.handleSwipeAnimation} cancelSwipeAnimation={this.props.cancelSwipeAnimation}/>);
    this.setState({
      renderedContent: renderedContent
    });
  }

  renderTimeline = (content, contentParent) => {
    let renderedContent = (<TimelineSeattle items={content} screen={this.props.screen} parent={contentParent} regionWidth={this.props.regionWidth} regionHeight={this.props.regionHeight} handleSwipeAnimation={this.props.handleSwipeAnimation} cancelSwipeAnimation={this.props.cancelSwipeAnimation}/>);
    this.setState({
      renderedContent: renderedContent
    });
  }

  renderDonorList = (content, contentParent) => {
    let renderedContent = (<DonorListSeattle items={content} parent={contentParent} regionWidth={this.props.regionWidth} handleSwipeAnimation={this.props.handleSwipeAnimation} cancelSwipeAnimation={this.props.cancelSwipeAnimation}/>);
    this.setState({
      renderedContent: renderedContent
    });
  }

  render() {
    let renderedContent = this.state.renderedContent;
    let style = {
      position: "absolute",
      top: this.state.top,
      right: this.state.right,
      background: this.props.backgroundColor,
      borderBottomLeftRadius: "50%",
      borderTopLeftRadius: "50%",
      height: this.state.radius,
      width: this.state.radius
    }

    return (
      <div>
        <div style={{ position: "absolute", height: this.props.regionHeight, width: this.props.regionWidth, overflow: "hidden", top: this.props.contentY, left: this.props.contentX }}>
          {/* background */}
          <CSSTransitionGroup
            component='div'
            className="fastfadedelay"
            style={{ minHeight: '100%' }}
            transitionName='example'
            transitionEnterTimeout={0}
            transitionLeaveTimeout={0}>
            <div key={this.props.backgroundColor} style={{ ...style }}>

            </div>
          </CSSTransitionGroup>
        </div>
        <div style={{ position: "absolute", height: this.props.regionHeight, width: this.props.regionWidth, top: this.props.contentY, left: this.props.contentX }}>
          {/* inner content */}
          <CSSTransitionGroup
          component='div'
          className="fastfadedelay"
          style={{ minHeight: '100%' }}
          transitionName='example'
          transitionEnterTimeout={0}
          transitionLeaveTimeout={0}>
          <div style={{ position:"absolute", top: 0.01305 * this.props.regionWidth, width: 0.4141 * this.props.regionWidth, left: 0.5693 * this.props.regionWidth, height:0.5287 * this.props.regionWidth }} key={this.props.content ? this.props.content.id : null}>
            {this.props.content ?
              renderedContent
              : 
              null
            }
          </div>
        </CSSTransitionGroup>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    stateContent: state.content,
    screen: state.screen,
    donors: state.donors
  }
}

export default connect(mapStateToProps, null)(ContentSeattle);


// WEBPACK FOOTER //
// ./src/Components/Theme/Seattle/ContentSeattle.jsx